var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "CookieConsentBlock" } }, [
    _c("div", { staticClass: "block_wrapper" }, [
      _c("div", { staticClass: "block_text" }, [
        _c("ul", [
          _c("li", [
            _vm._v(
              "\n              We use cookies to help us better understand how the site is used and to enable you to share content on social networks.\n          "
            )
          ]),
          _c("li", [
            _vm._v(
              '\n              We retain your choice for 6 months. You can change your mind at any time by clicking on the "manage cookies" button at the bottom of any page.\n          '
            )
          ]),
          _c("li", [
            _vm._v("\n            By "),
            _c(
              "a",
              {
                on: {
                  click: function($event) {
                    return _vm.refuseCookies()
                  }
                }
              },
              [_vm._v("closing this panel")]
            ),
            _vm._v(", you refuse all cookies.\n          ")
          ])
        ])
      ]),
      _c("div", { staticClass: "block_buttons" }, [
        _c(
          "a",
          {
            staticClass: "block_bt bt_accept",
            on: {
              click: function($event) {
                return _vm.activateGTag()
              }
            }
          },
          [_vm._v("Accept all")]
        ),
        _c(
          "a",
          {
            staticClass: "block_bt bt_refuse",
            on: {
              click: function($event) {
                return _vm.refuseCookies()
              }
            }
          },
          [_vm._v("Refuse all")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14079706", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14079706","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/cookiesConsent.vue
// module id = UJYB
// module chunks = 0 1 2 3 4 5